export { default as Footer } from "./Footer/Footer";
export { default as Navbar } from "./Navbar/Navbar";
export { default as NotFound } from "./NotFound/NotFound";
export { default as Sidebar } from "./Sidebar/SideBar";
export { default as VerifyLogin } from "./VerifyLogin";
